import { motion } from "framer-motion";
import { Check, ArrowRight, Youtube } from "lucide-react";
import { Eyebrow, Reveal, EASE } from "./Reveal";
import { scrollToId } from "../lib/scroll";
import { IMG, YOUTUBE_URL } from "../site";

const POINTS = [
    "Personalized training plans",
    "Competition preparation",
    "Asana correction",
    "Performance refinement",
    "Flexibility development",
    "Strength & stamina",
    "Mental preparation",
    "Presentation practice",
    "Tournament guidance",
];

export default function Coaching() {
    return (
        <section id="coaching" data-testid="coaching-section" className="relative py-20 sm:py-28 lg:py-32">
            <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-8 lg:grid-cols-2 lg:px-16">
                <div>
                    <Eyebrow>Personal Coaching</Eyebrow>
                    <Reveal>
                        <h2 className="mt-6 font-display text-4xl leading-[1.02] tracking-wide sm:text-5xl lg:text-6xl">
                            TRAIN LIKE A <span className="text-gold-grad">COMPETITOR</span>
                        </h2>
                        <p className="mt-6 max-w-lg text-[15px] leading-relaxed text-[#B8B8B8] sm:text-base">
                            Personalized one-on-one coaching is available for athletes
                            preparing for yoga and yogasana tournaments — from your first
                            assessment to competition day, every session is engineered for
                            the podium.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <button
                            data-testid="coaching-cta-book"
                            onClick={() => scrollToId("contact")}
                            className="btn-gold mt-9"
                        >
                            Book Personal Coaching <ArrowRight size={15} />
                        </button>
                    </Reveal>
                    <Reveal delay={0.25}>
                        <div className="gold-frame mt-12 overflow-hidden rounded-2xl p-[1.5px]">
                            <img
                                src={IMG.inversion}
                                alt="Advanced yogasana inversion trained for competition"
                                className="w-full rounded-2xl grayscale contrast-110"
                                loading="lazy"
                            />
                        </div>
                    </Reveal>
                </div>

                <Reveal delay={0.1}>
                    <div
                        data-testid="coaching-checklist"
                        className="glass rounded-3xl p-8 sm:p-10"
                    >
                        <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#F5C542]">
                            Tournament Coaching Covers
                        </p>
                        <ul className="mt-7 flex flex-col gap-4">
                            {POINTS.map((point, i) => (
                                <motion.li
                                    key={point}
                                    className="flex items-center gap-4"
                                    initial={{ opacity: 0, x: 24 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true, amount: 0.3 }}
                                    transition={{ duration: 0.55, delay: i * 0.06, ease: EASE }}
                                >
                                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#F5C542]/50">
                                        <Check size={12} className="text-[#F5C542]" />
                                    </span>
                                    <span className="text-sm font-medium tracking-wide text-white/85">
                                        {point}
                                    </span>
                                </motion.li>
                            ))}
                        </ul>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
